import * as React from "react";
import {Control, Field, Input, Label, Select} from "bloomer";
import InputWarning from "../../../../../elements/InputWarning";
import VideoToTextLanguages from "../../../../../components/model/VideoToText/VideoToTextLanguages";
import {INVALID_FIELD_STYLE} from "../../../../../utils/Constants";

interface IVideoToTextModelInputState {
    languageCode: string;
    languages: any;
    urlInput: string;
    urlInputEmpty: boolean;
    urlInputInvalid: boolean;
    invalidYoutubeUrl: boolean;
};

interface IVideoToTextModelInputProps {
    showUserInputsOnly?: boolean;
}

class VideoToTextModelInput extends React.Component<IVideoToTextModelInputProps, IVideoToTextModelInputState> {
    public URL_REGEX = new RegExp('^(((http|https):\\/\\/)|(www\\.))[^ "]+$');
    public YOUTUBE_URL_REGEX = new RegExp('^((http|https):\\/\\/)((youtube\\.com\\/)|(www\\.youtube\\.com\\/)|(youtu\\.be\\/)|(m\\.youtube\\.com\\/))[^ "]+$');
    public YOUTUBE_URL_REGEX_2 = new RegExp('^((www\\.youtube\\.com\\/)|(www\\.youtu\\.be\\/)|(www\\.m\\.youtube\\.com\\/))[^ "]+$');

    public constructor(props: IVideoToTextModelInputProps) {
        super(props);

        this.state = {
            languageCode: "en-US",
            languages: [],
            urlInput: "",
            urlInputEmpty: false,
            urlInputInvalid: false,
            invalidYoutubeUrl: false,
        };
    }

    public async componentDidMount() {
        const languages = await VideoToTextLanguages.list();
        if (languages) {
            this.setState({
                languages
            });
        }
    }

    public handleLanguageCodeChange = (e: any) => {
        this.setState({
            languageCode: e.target.value
        });
    };

    public handleURLInputChange = (e: any) => {
        const value = e.target.value;
        let valid = true;
        let urlInputEmpty = false;
        let invalidYoutubeUrl = false;
        if (value.trim()) {
            valid = this.URL_REGEX.test(value.trim());
            if (valid) {
                invalidYoutubeUrl = !(this.YOUTUBE_URL_REGEX.test(value.trim()) || this.YOUTUBE_URL_REGEX_2.test(value.trim()));
            }
        } else {
            urlInputEmpty = true;
        }

        this.setState({
            urlInput: value,
            urlInputInvalid: !valid,
            invalidYoutubeUrl,
            urlInputEmpty
        });
    };

    public validateForm = () => {
        if (this.props.showUserInputsOnly) {
            return true; // languageCode is always selected;
        } else {
            if (!this.state.urlInput.trim() || this.state.urlInputInvalid || this.state.invalidYoutubeUrl) {
                if (!this.state.urlInput.trim()) {
                    this.setState({
                        urlInputEmpty: true,
                        urlInputInvalid: false,
                        invalidYoutubeUrl: false
                    });
                }
                return false;
            }
            return true;
        }
    };

    public getFormData = (modelNamePrefix: string) => {
        const data: any = {
            language_code: this.state.languageCode
        };
        if (!this.props.showUserInputsOnly) {
            data.url = this.state.urlInput.trim();
        }
        const formData = new FormData();
        Object.keys(data).forEach((key: string) => {
            formData.append(`${modelNamePrefix}.${key}`, data[key]);
        });
        return formData;
    };

    public resetForm = () => {
        this.setState({
            languageCode: "en-US",
            urlInput: "",
            urlInputEmpty: false,
            urlInputInvalid: false,
            invalidYoutubeUrl: false
        });
    };

    public render() {
        return <React.Fragment>
            <Field>
                <Label>Language</Label>
                <Control>
                    <Select
                        onChange={this.handleLanguageCodeChange}
                        value={this.state.languageCode}
                    >
                        {
                            this.state.languages.map((lang: any) => {
                                return <option key={lang.code} value={lang.code}>{lang.name}</option>
                            })
                        }
                    </Select>
                </Control>
            </Field>
            <Field>
                <Label>YouTube video URL</Label>
                <Control>
                    <Input
                        style={(this.state.urlInputEmpty || this.state.urlInputInvalid || this.state.invalidYoutubeUrl)
                            ? INVALID_FIELD_STYLE : undefined}
                        type="text"
                        placeholder="Enter video url here"
                        value={this.state.urlInput}
                        onChange={this.handleURLInputChange}
                    />
                    <div>
                        {
                            this.state.urlInputEmpty && <InputWarning>Please input URL.</InputWarning>
                        }
                        {
                            this.state.urlInputInvalid && <InputWarning>Please input valid URL.</InputWarning>
                        }
                        {
                            this.state.invalidYoutubeUrl && <InputWarning>Please input valid YouTube URL.</InputWarning>
                        }
                    </div>
                </Control>
            </Field>
        </React.Fragment>;
    }
}

export default VideoToTextModelInput;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/CrossProvider/input/VideoToText/VideoToTextModelInput.tsx